import * as React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import ReportGmailerrorredRoundedIcon from '@mui/icons-material/ReportGmailerrorredRounded'
import { useTheme } from '@mui/material/styles'

class ErrorBoundaryCore extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] error capturado (pantalla blanca evitada):', error, errorInfo)
    this.setState({ errorInfo })
  }

  handleReload = () => {
    window.location.reload()
  }

  handleGoHome = () => {
    window.location.hash = '#/'
    window.location.reload()
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children
    }

    return (
      <ErrorPanel
        message={this.state.error?.message}
        errorName={this.state.error?.name}
        stack={this.state.errorInfo?.componentStack}
        onReload={this.handleReload}
        onGoHome={this.handleGoHome}
      />
    )
  }
}

function ErrorPanel({ message, errorName, stack, onReload, onGoHome }) {
  const theme = useTheme()

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '50vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        py: 6,
        px: 3,
      }}
    >
      <ReportGmailerrorredRoundedIcon sx={{ fontSize: 64, color: theme.palette.error.main }} />
      <Typography variant='h5' align='center'>
        Algo salió mal en esta sección
      </Typography>
      <Typography variant='body2' align='center' sx={{ color: 'text.secondary', maxWidth: 640 }}>
        ¿Nos ayudás reportando el
        siguiente detalle?
      </Typography>
      <Box
        sx={{
          maxWidth: 720,
          width: '100%',
          p: 2,
          borderRadius: 1,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'auto',
          maxHeight: 220,
        }}
      >
        <Typography
          variant='caption'
          component='pre'
          sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', m: 0 }}
        >
          {message} {errorName ? `(${errorName})` : ''}
        </Typography>
        {stack ? (
          <Typography
            variant='caption'
            component='pre'
            sx={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              m: 0,
              mt: 1,
              color: 'text.secondary',
            }}
          >
            {stack}
          </Typography>
        ) : null}
      </Box>
      <Stack direction='row' spacing={2}>
        <Button variant='contained' color='primary' onClick={onReload}>
          Recargar
        </Button>
        <Button variant='outlined' color='inherit' onClick={onGoHome}>
          Volver al inicio
        </Button>
      </Stack>
    </Box>
  )
}

export const ErrorBoundary = ErrorBoundaryCore
